import api from "../../../settings/api";
import { clearString, isPJ } from "../../../utils/functions";
import { AxiosResponse } from "axios";
import { call } from "redux-saga/effects";

export interface Fetch {
    document: string;
    name?: string;
    email?: string;
    phone?: string;
    licensePlate?: string;
}

export interface CreateCustomerAction {
    type: string;
    payload: Fetch;
}

interface CreateCustomerResponse {
    data?: {
        nrc?: string;
    };
}

export default function* createCustomer({
    payload,
}: CreateCustomerAction): Generator<ReturnType<typeof call>, string, AxiosResponse<CreateCustomerResponse>> {
    try {
            
        if (!payload.document) {
            throw new Error('Document is required');
        }

        const personType = (isPJ(payload.document) ? 2 : 1);
        
        const data: {
            document: string;
            personType: number;
            name?: string;
            licensePlate?: string;
            contactInfo?: {
                email?: string;
                phoneNumber?: string;
            };
        } = {
            document: clearString(payload.document.toLocaleUpperCase()),
            personType,
        };

        if (payload.name) {
            data.name = payload.name;
        }

        if (payload.licensePlate) {
            data.licensePlate = clearString(payload.licensePlate.toLocaleUpperCase());
        }

        if (payload.email || payload.phone) {
            data.contactInfo = {};
            
            if (payload.email) {
                data.contactInfo.email = payload.email;
            }

            if (payload.phone) {
                data.contactInfo.phoneNumber = clearString(payload.phone);
            }

        }
        const response = yield call(api.post, `/v1/customers`, data);

        return response?.data?.data?.nrc ?? "";

    } catch (error) {
        return "";
    }
}